import { useEffect, useRef } from 'react'
import { toast } from 'react-toastify'
import useNetworkStatus from 'services/hooks/useNetworkStatus'

const OFFLINE_TOAST_ID = 'network-status-offline'

const NetworkStatusNotifier = () => {
  const { isOffline } = useNetworkStatus()
  const hasShownOnlineRecovery = useRef(false)

  useEffect(() => {
    if (isOffline) {
      hasShownOnlineRecovery.current = true
      toast.warning('You are offline. Some actions are unavailable until connection is restored.', {
        autoClose: false,
        closeOnClick: false,
        draggable: false,
        toastId: OFFLINE_TOAST_ID,
      })
      return
    }

    toast.dismiss(OFFLINE_TOAST_ID)

    if (hasShownOnlineRecovery.current) {
      toast.success('Connection restored.', { autoClose: 3000 })
      hasShownOnlineRecovery.current = false
    }
  }, [isOffline])

  return null
}

export default NetworkStatusNotifier
